import { memo } from "react";
import { View } from "react-native";
import StyledText from "../../common/ui/styled-text";

const CallCardSeparator = ({ className }: { className?: string }) => {
  return (
    <View className={`py-2 mb-4 ${className || ""}`}>
      <StyledText className="text-base font-semibold text-primary text-center">
        Older calls
      </StyledText>
    </View>
  );
};

export default memo(CallCardSeparator);
